import MappingTabs from './MappingTabs'
export default MappingTabs



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/index.js